var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5945D4BA-2DD5-41A2-BB0A-87D711C2ED40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-130.000000, -254.000000)",
    fill: "#69C300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happy",
    transform: "translate(130.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C8.97217391,0 0,8.97217391 0,20 C0,31.0278261 8.97217391,40 20,40 C31.0278261,40 40,31.0278261 40,20 C40,8.97217391 31.0278261,0 20,0 Z M20,38.2608696 C9.93043478,38.2608696 1.73913043,30.0695652 1.73913043,20 C1.73913043,9.93043478 9.93043478,1.73913043 20,1.73913043 C30.0695652,1.73913043 38.2608696,9.93043478 38.2608696,20 C38.2608696,30.0695652 30.0695652,38.2608696 20,38.2608696 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521739,16.5217391 C15.6521739,15.0834783 14.4817391,13.9130435 13.0434783,13.9130435 C11.6052174,13.9130435 10.4347826,15.0834783 10.4347826,16.5217391 C10.4347826,17.96 11.6052174,19.1304348 13.0434783,19.1304348 C14.4817391,19.1304348 15.6521739,17.96 15.6521739,16.5217391 Z M12.173913,16.5217391 C12.173913,16.0426087 12.5643478,15.6521739 13.0434783,15.6521739 C13.5226087,15.6521739 13.9130435,16.0426087 13.9130435,16.5217391 C13.9130435,17.0008696 13.5226087,17.3913043 13.0434783,17.3913043 C12.5643478,17.3913043 12.173913,17.0008696 12.173913,16.5217391 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9565217,13.9130435 C25.5182609,13.9130435 24.3478261,15.0834783 24.3478261,16.5217391 C24.3478261,17.96 25.5182609,19.1304348 26.9565217,19.1304348 C28.3947826,19.1304348 29.5652174,17.96 29.5652174,16.5217391 C29.5652174,15.0834783 28.3947826,13.9130435 26.9565217,13.9130435 Z M26.9565217,17.3913043 C26.4773913,17.3913043 26.0869565,17.0008696 26.0869565,16.5217391 C26.0869565,16.0426087 26.4773913,15.6521739 26.9565217,15.6521739 C27.4356522,15.6521739 27.826087,16.0426087 27.826087,16.5217391 C27.826087,17.0008696 27.4356522,17.3913043 26.9565217,17.3913043 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.406087,24.5695652 C28.0478261,24.2486957 27.4973913,24.28 27.1782609,24.6373913 C25.3643478,26.6643478 22.7486957,27.826087 20,27.826087 C17.2521739,27.826087 14.6356522,26.6643478 12.8217391,24.6373913 C12.5008696,24.28 11.9521739,24.2486957 11.593913,24.5695652 C11.2356522,24.8895652 11.206087,25.4391304 11.526087,25.7973913 C13.6695652,28.1921739 16.7582609,29.5652174 20,29.5652174 C23.2426087,29.5652174 26.3313043,28.1913043 28.473913,25.7973913 C28.793913,25.4391304 28.7634783,24.8895652 28.406087,24.5695652 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.bad733e315ff8cfaed6d11ba5ada5711.svg";
export { ForwardRef as ReactComponent };